import React, { useState, useEffect, useMemo } from "react";
import { Box, Typography, Drawer, IconButton, useMediaQuery } from "@mui/material";
import { useNavigate, useLocation, Link } from "react-router-dom";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CloseIcon from "@mui/icons-material/Close";
//import Buildinfo from "../../../mainpage/BuildInfo";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";

const SidebarComponent = () => {
  const [selected, setSelected] = useState("Learning Path");
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isDesktop = useMediaQuery("(min-width : 1024px)");

  useEffect(() => {
    setIsSidebarVisible(isDesktop);
  }, [isDesktop]);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (token) {
      localStorage.setItem("token", token);
      setSelected("Learning Path");
      navigate("/learners/dashboard");
    }
  }, [navigate]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) navigate("https://site.huebits.in/learners");
  }, [navigate]);

  const menuItems = useMemo(() => [
    { title: "Dashboard", to: "/learners/dashboard", icon: <SpaceDashboardOutlinedIcon  /> },
    { title: "Learning Path", to: "/learners/dashboard/internetofthings", icon: <AutoStoriesOutlinedIcon /> },
    { title: "Courses", to: "/learners/dashboard/courses", icon: <MenuBookOutlinedIcon /> },
    { title: "Projects", to: "/learners/dashboard/projects", icon: <FactCheckOutlinedIcon /> },
    { title: "Mentor Connect", to: "/learners/dashboard/mentorconnect", icon: <SupportAgentOutlinedIcon /> },
    { title: "Apply For Work", to: "/learners/dashboard/work", icon: <BusinessCenterOutlinedIcon /> },
    { title: "Ideavize AI", to: "/learners/dashboard/ideavize-ai", icon: <LightbulbOutlinedIcon /> },
    { title: "Profile", to: "/learners/dashboard/userprofile", icon: <AccountCircleOutlinedIcon /> },
  ], []);

  useEffect(() => {
    const currentMenu = menuItems.find(item => item.to === location.pathname);
    setSelected(currentMenu ? currentMenu.title : "");
  }, [location.pathname, menuItems]);

  const Item = ({ title, to, icon, selected, setSelected }) => {
    const isActive = selected === title;

    const handleClick = () => {
      setSelected(title);
      if (title === "LogOut") {
        localStorage.removeItem("token");
        navigate("https://site.huebits.in/learners");
      } else if (to) {
        navigate(to);
      }
      if (!isDesktop) setIsSidebarVisible(false);
    };

    return (
      <Box
        onClick={handleClick}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: "12px 24px",
          margin: "6px 12px",
          borderRadius: "10px",
          backgroundColor: isActive ? "#1b6ef4" : "#f9f9f9",
          color: isActive ? "white" : "#333",
          cursor: "pointer",
          transition: "all 0.3s",
          "&:hover": {
            backgroundColor: "#1b6ef4",
            color: "white",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            "& .icon": {
            color: "white",
          },
          },
        }}
      >
        {React.cloneElement(icon, {
          className: "icon",
          sx: {
            fontSize: 22,
            marginRight : "16px",
            color: isActive ? "white" : "#1b6ef4",
            transition: "color 0.3s",
          },
        })}
        <Typography sx={{ fontWeight: 500 }}>{title}</Typography>
      </Box>
    );
  };

  return (
    <>
      <Drawer
        anchor="left"
        open={isSidebarVisible}
        variant={isDesktop ? "persistent" : "temporary"}
        onClose={() => setIsSidebarVisible(false)}
        sx={{
          width : 240,
          "& .MuiDrawer-paper": {
            width : 240,
            boxSizing: "border-box",
            padding: "20px 0",
            backgroundColor: "#ffffff",
            boxShadow: isDesktop ? "none" : "4px 0 12px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <Box sx={{ px: 3, mb: 2, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: "32px",
              fontWeight: "700",
              color: "rgb(2, 41, 100)",
              textDecoration: "none",
              textAlign:"center"
            }}
            component={Link}
            to="#"
          >
            Hue<span style={{ color: "rgb(14, 104, 249)" }}>bits</span>
          </Typography>
          {!isDesktop && (
            <IconButton onClick={() => setIsSidebarVisible(false)}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>

        <Box>
          {menuItems.map((item, index) => (
            <Item
              key={index}
              title={item.title}
              to={item.to}
              icon={item.icon}
              selected={selected}
              setSelected={setSelected}
            />
          ))}
        </Box>
         {/* Add BuildInfo at the bottom */}
        {/* <Box sx={{ mt: "auto", px: 3, pt: 2 }}>
          <Buildinfo />
        </Box> */}
      </Drawer>

      {!isSidebarVisible && !isDesktop && (
        <IconButton
          onClick={() => setIsSidebarVisible(true)}
          sx={{
            position: "fixed",
            top : "12px",
            left : "12px",
            backgroundColor: "#1b6ef4",
            color: "#fff",
            zIndex: 1300,
            "&:hover": {
              backgroundColor: "#1454c4",
            },
          }}
        >
          <MenuOutlinedIcon />
        </IconButton>
      )}
    </>
  );
};

export default SidebarComponent;
